import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    reports: []
};

const reportSlice = createSlice({
    name: 'report',
    initialState,
    reducers: {
        setReports: (state, action) => {
            state.reports = action.payload;
        },
        updateReportRoles: (state, action) => {
            const { reportId, roleIds } = action.payload;
            const report = state.reports.find(r => r.reportId === reportId);
            if (report) {
                report.roleIds = roleIds;
            }
        },
        resetReports: (state) => {
            state.reports = [];
        }
    }
});

export const { setReports, updateReportRoles, resetReports } = reportSlice.actions;
export default reportSlice.reducer;